(function() {
    'use strict';
    
    angular.module('vhols')
    
        .service('price', function() {
            function Price(adultPrice, adultSaving, freeText, startDate, endDate) {
                var DATE_INPUT_FORMAT = 'YYYY-MM-DD';
                
                this.adultPrice = parseInt(adultPrice, 10);
                this.adultSaving = parseInt(adultSaving, 10);
                this.freeText = freeText;
                this.startDate = moment(startDate, DATE_INPUT_FORMAT);
                this.endDate = moment(endDate, DATE_INPUT_FORMAT);
                this.isOffer = this.adultSaving > 0;
                this.notSameDate = !this.startDate.isSame(this.endDate);
            }

            Price.prototype.startsAfter = function(filterStartDate) {
                if (!filterStartDate) {
                    return true;
                }
                
                return this.startDate.isSameOrAfter(moment(filterStartDate));
            };
            
            Price.prototype.endsBefore = function(filterEndDate) {
                if (!filterEndDate) {
                    return true;
                }
                
                return this.endDate.isSameOrBefore(moment(filterEndDate));
            };
             
            Price.prototype.inDateRange = function(filterStartDate, filterEndDate) {
                if (filterStartDate && filterEndDate) {
                    var start = this.startsAfter(filterStartDate);
                    var end = this.endsBefore(filterEndDate);
                    
                    return !start && !end;
                }
                
                return false;
            };
            
            return Price;
        });
        
})();